


export class NL_Siparis {


        ID: number;

        StokKartID: number;

        IslemTuru: number;

        FaturaID: number;

        SatirNo: number;

        CariKartID: number;

        DepoKodu: number;

        Miktar: number;

        BirimFiyat: number;

        IskontoOran1: number;

        IskontoOran2: number;

        IskontoOran3: number;

        IskontoTutar: number;

        IskontoluBirimFiyati: number;

        AraTutar: number;

        Kdv: number;
        Tutar: number;

        KdvOran: number;

        SlsMan: string;

        Sign: number;

        SaticiRef: number;

        Maliyet: number;
        Kalan: number;

        NetFiyat: number;

        siparisID: number;
        UrunName: string;
        SIPARIS_DURUM_ID: number;


        // @ManyToMany(type => M_ITEMS, a => a.LOGICALREF)
        // @JoinTable()
        // FK_ITEM: M_ITEMS

}



// WEBPACK FOOTER //
// ./src/models/NL_Siparis.ts